import AuthRoutes from "../auth/routes/AuthRoutes";

export const publicRoutes = [
  {
    path: "/*",
    element: <AuthRoutes />,
  },
];
